import { DEPT_WORK_ID } from '@kdk/shared';
import { tokens } from '@kdk/shared/theme';

const hashOf = (id: string): number =>
  Array.from({ length: id.length }, (_, i) => id.charCodeAt(i)).reduce((total, c) => total + c, 0);

/** 案件ごとの識別色(配分バー・凡例で共通)。明るさ(L)はテーマごとの変数なので、背景に合わせて変わる。 */
export const caseColor = (caseId: string): string => {
  if (caseId === DEPT_WORK_ID) return tokens.stage[1];
  const n = Number(caseId.replace(/\D/g, ''));
  const index = Number.isFinite(n) && n > 0 ? n - 1 : hashOf(caseId);
  return `hsl(${(index * 53 + 200) % 360} 55% ${tokens.caseL})`;
};
